import { render, staticRenderFns } from "./UiBanner.vue?vue&type=template&id=4fa8cc4e&"
import script from "./UiBanner.vue?vue&type=script&lang=ts&"
export * from "./UiBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports